import { useMemo } from 'react';

import adminInboundService from '@services/admin/inboundService';

/**
 * Admin Inbound Service Hook
 *
 * 簡單包裝 adminInboundService，保持與 operator hook 的一致性
 *
 * @returns {Object} inboundService
 *
 * @example
 * const inboundService = useAdminInboundService();
 *
 * await inboundService.create({ name: 'Inbound A', inbound_type: 'receiving' });
 * await inboundService.getById(1);
 */
export function useAdminInboundService() {
  return useMemo(() => adminInboundService, []);
}
